module.exports = __webpack_public_path__ + "static/media/list_selected.ebea9d10.svg";